import { FormState } from '../../features/form/ducks';

export enum VersionFlag {
  CURRENT = '2',
  OUTDATED = '1',
}

export enum VerificationFlag {
  OUTDATED = 'outdated',
  VERIFIED = 'verified',
}

export enum SignatureFlag {
  OUTDATED = 'outdated',
  SIGNED = 'signed',
}

export enum SignatureScope {
  AGREEMENT = 'agreement',
  CUSTOMER_INFO_1 = 'customerInfo1',
  CUSTOMER_INFO_2 = 'customerInfo2',
  GENERAL_AGREEMENT = 'generalAgreement',
  INVESTING = 'investing',
  MEETING = 'meeting',
  MOVENTUM = 'bestOfTempleton',
  PROTOCOL = 'protocol',
}

interface Verification {
  customer1: {
    email?: VerificationFlag;
    sms?: VerificationFlag;
  };
}

interface Signature {
  customer1: {
    // E.g. { 'agreement': 'signed' }
    sms: Partial<Record<SignatureScope, SignatureFlag>>;
  };
}

export interface Transaction {
  type: 'questionnaire';
  status: 'new';
  benefits: [];
  appliedBenefits: [];
  parents: [];
  children: [];
  journal: [];
  time: string;
  owner: string;
  entries: [{ meta: FormState }];
  price: { amount: 0; currency: 'EUR' };
  meta: {
    signature?: Signature;
    verification?: Verification;
    version: VersionFlag;
  };
  author: string;
  createdAt: string;
  updatedAt: string;
  id: string;
  _id: string;
}
